module.exports = "//static.hsappstatic.net/settings-ui-app/static-1.14467/images/double-opt-in-edit-upgrade.jpg"